var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jyh-contact"},[_c('contact-header'),_vm._v(" "),_c('contact-body'),_vm._v(" "),_c('y-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }